import { render } from "./AdminComment.vue?vue&type=template&id=318585bc&scoped=true&ts=true"
import script from "./AdminComment.vue?vue&type=script&lang=ts"
export * from "./AdminComment.vue?vue&type=script&lang=ts"

import "./AdminComment.vue?vue&type=style&index=0&id=318585bc&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318585bc"]])

export default __exports__